// extracted by mini-css-extract-plugin
export default {"phoneNumberStyles":"TogoContentHeader_phoneNumberStyles__yF3H6","inputBox":"TogoContentHeader_inputBox__i2PuW"};